import { c as _c } from "react/compiler-runtime";
import { useTooltip } from "@website/ui/tooltip/tooltip.hook";
import styles from "@website/ui/tooltip/tooltip.module.scss";
import { TooltipPropertiesType } from "@website/ui/tooltip/tooltip.types";
import { FC } from "react";
export const Tooltip: FC<TooltipPropertiesType> = properties => {
  const $ = _c(11);
  const {
    title,
    children,
    placement,
    color,
    variant,
    className,
    titleClassName
  } = properties;
  const {
    titleProperties,
    tooltipProperties
  } = useTooltip(properties);
  const t0 = `${titleClassName} ${styles.title} ${styles[placement || "bottom"]} ${styles[color || "neutral"]} ${styles[variant || "wrap"]}`;
  let t1;
  if ($[0] !== t0 || $[1] !== title || $[2] !== titleProperties) {
    t1 = <span className={t0} {...titleProperties}>{title}</span>;
    $[0] = t0;
    $[1] = title;
    $[2] = titleProperties;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1 || $[6] !== tooltipProperties) {
    t2 = <div className={`${styles.tooltip} !w-full`} {...tooltipProperties}>{children}{t1}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = tooltipProperties;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== className || $[9] !== t2) {
    t3 = <div className={className}>{t2}</div>;
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};